module.exports = __webpack_public_path__ + "img/mwb.26893c3.png";